import { createApp } from 'vue'
import App from './App.vue'
import { setJhaWcTheme, JHA_THEMES } from '@banno/jha-wc/src/styles/theme-provider.js'

setJhaWcTheme(JHA_THEMES.JHA_ADMIN)

createApp(App).mount('#app')
